import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { aggregatedClasses } from '@elliemae/ds-classnames';

var pillBlockName = 'pill';
var PillWrapper = aggregatedClasses('div')(pillBlockName, null, function (_ref) {
  var _ref2;

  var size = _ref.size,
      variant = _ref.variant;
  return _ref2 = {}, _defineProperty(_ref2, variant, !!variant), _defineProperty(_ref2, size, !!size), _ref2;
});
var PillLabel = aggregatedClasses('span')(pillBlockName, 'label');
var PillAddon = aggregatedClasses('div')(pillBlockName, 'addon');

function Pill(_ref3) {
  var _ref3$containerProps = _ref3.containerProps,
      containerProps = _ref3$containerProps === void 0 ? {} : _ref3$containerProps,
      _ref3$label = _ref3.label,
      label = _ref3$label === void 0 ? '' : _ref3$label,
      leftAddon = _ref3.leftAddon,
      rightAddon = _ref3.rightAddon,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === void 0 ? 'value' : _ref3$variant,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 'm' : _ref3$size,
      otherProps = _objectWithoutProperties(_ref3, ["containerProps", "label", "leftAddon", "rightAddon", "variant", "size"]);

  return /*#__PURE__*/React.createElement(PillWrapper, _extends({}, containerProps, {
    classProps: {
      variant: variant,
      size: size
    }
  }, otherProps), leftAddon && /*#__PURE__*/React.createElement(PillAddon, null, leftAddon), /*#__PURE__*/React.createElement(PillLabel, null, label), rightAddon && /*#__PURE__*/React.createElement(PillAddon, null, rightAddon));
}

var props = {
  /** props to inject to pill wrapper */
  containerProps: PropTypes.object.description('props to inject to pill wrapper'),

  /** pill text label */
  label: PropTypes.string.isRequired.description('pill text label'),

  /** pill size */
  size: PropTypes.oneOf(['m', 'l']).description('pill size'),

  /** pill variant */
  variant: PropTypes.oneOf(['value', 'title']).description('pill variant'),

  /** addon component to left */
  leftAddon: PropTypes.node.description('addon component to left'),

  /** addon component to right */
  rightAddon: PropTypes.node.description('addon component to right')
};
Pill.propTypes = props;
var DSPillWithSchema = describe(Pill);
DSPillWithSchema.propTypes = props;

export default Pill;
export { DSPillWithSchema, Pill };
//# sourceMappingURL=Pill.js.map
